/**
 * 由 CoCo 源代码计划解包器解包
 *
 * 模块 ID：2042
 */

"use strict"

Object.defineProperty(exports, "__esModule", {
  value: true
})
exports.GroupEventType = undefined;
(function (e) {
  e.GroupStart = "GROUP_START"
  e.GroupEnd = "GROUP_END"
  e.GroupCancel = "GROUP_CANCEL"
})(exports.GroupEventType || (exports.GroupEventType = {}))
